<template>
  <div class="other-pay-share">
    <div class="card">
      <div class="title">
        <img :src="left_icon" class="semi" alt="" />
        <span>我急需在智云医道购买以下商品，快帮我付个款吧~</span>
        <img :src="right_icon" class="semi" alt="" />
      </div>
      <div class="content">
        <img :src="fukuan_icon" class="fukuan_icon" alt="" v-if="detail.payStatus === 1" />
        <div class="head">
          帮收货人
          <span>{{ detail.receiveName }}</span>
          代付
        </div>
        <div class="money" :class="{ money1: detail.payStatus === 99 }">
          <span class="icon">￥</span>
          <span class="amount" v-if="detail.amount">{{ (detail.amount / 100).toLocaleString() }}</span>
        </div>
        <template v-if="detail.payStatus === 0">
          <div class="tips">
            剩余支付时间
            <span class="timer">
              <span class="tt van-hairline--surround">{{ timer.hh }}</span>
              <span class="mm">:</span>
              <span class="tt van-hairline--surround">{{ timer.mm }}</span>
              <span class="mm">:</span>
              <span class="tt van-hairline--surround">{{ timer.ss }}</span>
            </span>
          </div>
          <div class="sub-button van-hairline--bottom">
            <van-button type="primary" size="middle" round block v-reClick="handlePay">慷慨付款</van-button>
          </div>
        </template>
        <template v-else>
          <div class="other-tip">
            <span v-if="detail.payStatus === 1">如发生退款，则原路返还</span>
            <span v-if="detail.payStatus === 99">代付订单已失效</span>
          </div>
        </template>
        <div class="dis">
          <div class="top">代付说明：</div>
          <div class="content1">
            1.付款前请电话或当面核实好友身份再付款，代付商品或服务不归你所有。
            <br />
            2.如果发生退款，钱将原路退还到你支付时选择的账户内。
          </div>
        </div>
      </div>
    </div>
    <div class="product" v-if="detail.visibleForOther === 1">
      <div class="head flex space-between align-center">
        <div>代付商品</div>
      </div>
      <div class="">
        <goods-item v-for="(item, key) in detail.itemList" :goods="item" :key="key"></goods-item>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import goodsItem from '@/components/goodsItem.vue';
import { Dialog } from '@zyf2e/capui-mobile';
import ZYPay from '@zyf2e/checkout-sdk';

import util from '../../util';

import left_icon from './img/left.png';
import right_icon from './img/right.png';
import fukuan_icon from './img/img_fukuan.png';

let timerInter;

export default {
  components: { goodsItem },
  data() {
    return {
      left_icon,
      right_icon,
      fukuan_icon,
      orderId: '',
      detail: {
        amount: ''
      },
      timer: {
        hh: '00',
        mm: '00',
        ss: '00'
      },
      pay: ''
    };
  },
  async mounted() {
    await ZYPay.init({
      ...util.ZYpayConfig,
      needLogin: false,
      successUrl: encodeURIComponent(window.location.href)
    });
    this.init();
  },
  beforeDestroy() {
    if (timerInter) clearTimeout(timerInter);
  },
  methods: {
    async handlePay() {
      try {
        await ZYPay.prePay({ tradeNo: this.detail.tradeNo });
      }catch(error) {
        if (error === 'INIT_ADAPT_ERROR') {
          Dialog.confirm({
            title: '温馨提示',
            message: '支付环境异常,请刷新重试',
            confirmButtonText: '立即重试'
          })
            .then(() => {
              window.location.reload()
              // on confirm
            })
            .catch((action) => {
              // on cancel or assist
            });
            return
        }
        this.$toast(error && error.message ? error.message : error);
      }
      
    },
    init() {
      this.orderId = this.$route.query.orderId;
      const token = util.getQueryVariable('token');
      this.$fetch.queryReplacePayInfo({ orderId: this.orderId }).then(async res => {
        if (token) {
          try {
            await ZYPay.prePay({ tradeNo: res.tradeNo, redirectUrl: window.location.href });
          }catch(error) {
            if (error === 'INIT_ADAPT_ERROR') {
              Dialog.confirm({
                title: '温馨提示',
                message: '支付环境异常,请刷新重试',
                confirmButtonText: '立即重试'
              })
                .then(() => {
                  window.location.reload()
                  // on confirm
                })
                .catch((action) => {
                  // on cancel or assist
                });
                return
            }
            this.$toast(error && error.message ? error.message : error);
          }
          
        }
        this.detail = res;
        if (res.payStatus === 0) {
          this.countDown();
        }
      });
    },

    countTimeStr() {
      const endDate = dayjs(this.detail.payExpireTime);
      const d = endDate.diff(dayjs(), 'day');
      const h = endDate.diff(dayjs(), 'hour');
      const m = endDate.diff(dayjs(), 'minute');
      const s = endDate.diff(dayjs(), 'second');

      const hh = h - d * 24;
      const mm = m - h * 60;
      const ss = s - m * 60;

      this.timer.hh = `00${hh}`.slice(-2);
      this.timer.mm = `00${mm}`.slice(-2);
      this.timer.ss = `00${ss}`.slice(-2);
    },

    countDown() {
      clearTimeout(timerInter);
      timerInter = setTimeout(() => {
        const countTime = this.detail.payExpireTime - Date.now();
        if (countTime > 0) {
          this.countDown();
        } else {
          clearTimeout(timerInter);
          this.detail.expireTime = Date.now();
          this.detail.payStatus = 99;
        }
        this.countTimeStr();
      }, 1000);
    }
  }
};
</script>

<style lang="less">
.other-pay-share {
  .card {
    width: 100%;
    min-height: 260px;

    background-position: 0% 0%;
    background: url('./img/bg_mall_top.png') no-repeat;
    background-size: 100vw;
    .title {
      padding: 24px 28px 0;
      font-size: 16px;
      color: #fff;
      line-height: 24px;
      .semi {
        width: 16px;
        margin: 0 8px;
      }
    }
    .content {
      padding: 16px;
      background: #ffffff;
      border-radius: 8px;
      margin: 24px 12px 0;
      position: relative;
      overflow: hidden;
      .fukuan_icon {
        position: absolute;
        right: 0;
        top: 0;
        width: 64px;
        height: 64px;
      }
      .head {
        color: #8c8c8c;
        margin-bottom: 10px;
        span {
          color: #ff8200;
        }
      }
      .money {
        color: #262626;
        height: 72px;
        text-align: center;
        padding: 18px;
        font-weight: bold;
        .icon {
          font-size: 20px;
        }
        .amount {
          font-size: 36px;
        }
      }
      .money1 {
        color: #8c8c8c;
      }
      .tips {
        color: #262626;
        justify-content: center;
        align-items: center;
        display: flex;
        .timer {
          margin-left: 4px;
          display: flex;
          color: #ff4e47;
          .tt {
            font-size: 12px;
            display: flex;
            width: 22px;
            height: 18px;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            &.van-hairline--surround::after {
              border-radius: 4px;
            }
          }
          .mm {
            padding: 0 3px;
          }
        }
      }
      .other-tip {
        color: #262626;
        justify-content: center;
        align-items: center;
        display: flex;
        padding-bottom: 32px;
        border-bottom: 1px solid #eee;
      }
      .sub-button {
        width: 100%;
        margin-top: 26px;
        padding-bottom: 20px;
        // border-bottom: 1px solid #eee;
      }
      .dis {
        .top {
          font-weight: 400;
          color: #262626;
          line-height: 20px;
          margin-top: 20px;
        }
        .content1 {
          margin-top: 6px;
          font-size: 12px;
          font-weight: 400;
          color: #8c8c8c;
          line-height: 21px;
        }
      }
    }
  }
  .product {
    background: #fff;
    border-radius: 8px;
    padding: 12px;
    margin: 10px 12px 28px;
    .head {
      padding: 8px 0;
      color: #262626;
    }
  }
}
</style>
